module.exports = __webpack_public_path__ + "static/media/walking-pizza.f9d675d1.svg";